// assets/js/main.js

// Global
import * as NavToggle from './modules/navToggle.js';
import * as ProjectItemCursor from './modules/projectItemCursor.js';
import * as EmailCopy from './modules/emailCopy.js';

// Projects
import * as WaveList from './modules/wave-list.js';
import * as ProjectsFilters from './modules/projectsFilters.js';
import * as ProjectsView from './modules/projectsView.js';
import * as ProjectGridReflow from './modules/projectGridReflow.js';
 
// Project
import * as ProjectStory from './modules/projectStory.js';

// Division (agence, studio)
import * as ServiceCarousel from './modules/serviceCarousel.js';
import * as PageHeaderShrink from './modules/pageHeaderShrink.js';

// Home
import * as ZScroll from './modules/zscroll-snap.js';
//import * as ZScroll from './modules/zscroll.js';
import * as CoverSlideshow from './modules/coverSlideshow.js';


/** 
 * Initialisation conditionnelle par template
 */
function initPage() {

    const template = document.body.dataset.template;

    // ========================================
    // CONTROLLERS GLOBAUX
    // ========================================

    NavToggle.init();
    //EmailCopy.init(); // désactivé temporairement (copie mailto -> presse-papier)
    //Cursor.init();
    //Footer.init();


    // ========================================
    // PARTOUT SAUF HOME
    // ========================================
  
    if (template !== 'home') {

        // Autres composants globaux (sauf home)
    }
  

    // ========================================
    // CONTROLLERS CONDITIONNELS PAR PAGE
    // ========================================
  
    switch(template) {

        // --------------------------------------
        case 'home':
            ZScroll.init();
            CoverSlideshow.init();
            break;

        // --------------------------------------
        case 'projects':
            //ProjectItemCursor.init();
            ProjectsView.init();
            ProjectsFilters.init();
            ProjectGridReflow.init();
            break;

        // --------------------------------------
        case 'division':
        case 'section':
            ServiceCarousel.init();
            PageHeaderShrink.init();
            break;

        // --------------------------------------
        case 'about':
            PageHeaderShrink.init();
            break;

        // --------------------------------------
        case 'projects-listpage':
            WaveList.init();
            ProjectsFilters.init();
            break;

        // --------------------------------------
        // --------------------------------------
        case 'project':
            ProjectStory.init();
            break;

        /*
        case 'about':
            break;

        // --------------------------------------
        case 'work':
            break;
        */
    }
  
  console.log('Page initialization complete');


}

/**
 * Cleanup avant navigation (préparation Swup)
 */
function cleanupPage() {
	const template = document.body.dataset.template;

	//console.log(`Cleaning up page: ${template}`);

	// Cleanup des controllers spécifiques à la page
	switch(template) {
		case 'home':
			ZScroll.destroy('zContainer');
			CoverSlideshow.destroy();
			break;

		case 'projects':
			//ProjectItemCursor.destroy();
			ProjectsView.destroy();
			ProjectsFilters.destroy();
			ProjectGridReflow.destroy();
			break;

		case 'division':
		case 'section':
			ServiceCarousel.destroy();
			PageHeaderShrink.destroy();
			break;

		case 'about':
			PageHeaderShrink.destroy();
			break;

		case 'projects-listpage':
			WaveList.destroy();
			ProjectsFilters.destroy();
			break;

        case 'project':
            ProjectStory.destroy();
            break;

        /*
		case 'about':
			break;
        */
	}

  
}

// ========================================
// INIT AU CHARGEMENT
// ========================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPage);
} else {
  initPage();
}
